import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Login from "../../views/Login/component";
import clearCartIcon from "../../images/clear-cart.png";
import NoCart from "../../images/no-cart.svg";
import { Modal, ModalFooter } from "reactstrap";
import { USER_DATA } from "./constant";
import { errorCodeMessages, notify, handleAddToCart } from "../../components/common/utils";
import { ondcSelect } from "../../slices/ondcPreorderSlice";
import { updateCartItem } from "../../slices/catalogSlice";
import ManageAddress from "../../views/ManageAddress/component";
import { DeleteIcon, MinusIcon, PlusIcon } from "../../components/svgicons";
import CrossIcon from "../../components/svgicons/Cross-icon";
import WarningIcon from "../../images/warning-icon.svg";
import "./styles.scss";
import { v4 as uuidv4 } from "uuid";
import BrandLogo from "../../images/kikoimg.svg";
import Plus from "../../components/svgicons/plus";
import { Helmet } from "react-helmet";
import { cloneDeep } from 'lodash';
import LoaderWhite from "./LoaderWhite";

const Cart = (props) => {
  let { closeCart } = props;
  let cartItems = JSON.parse(localStorage.getItem("cart"));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [clearCart, setClearCart] = useState(false);
  const [cartError, setCartError] = useState("");
  const [errMessage, setErrMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [addressModal, setAddressModal] = useState(false);
  const [zipcode, setZipcode] = useState("");
  const [cartItemsTemp, setCartItemsTemp] = useState(cartItems);
  const ondcCartDataLocal = JSON.parse(localStorage.getItem("ondcCart"));
  const [ondcCartData, setOndcCartData] = useState(ondcCartDataLocal);
  const [errorData, setErrorData] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isCartEmpty, setisCartEmpty] = useState(false);
  const [errorPopupOpen, setErrorPopupOpen] = useState(false);
  const [disableCrossButton, setDisableCrossButton] = useState(false);
  const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
  const [shippingAddress, setShippingAddress] = useState(
    defaultAddress?.address
  );
  const token = localStorage.getItem("token");
  useEffect(() => {
    if (errorData && errorData.length > 0 && !cartError) {
      setCartError("Cart has errors ! please try updating your cart.");
    }
  }, [errorData, cartItemsTemp]);

  useEffect(() => {
    let cartItems = JSON.parse(localStorage.getItem("cart"));
    setCartItemsTemp(cartItems || []);
  }, [props.isCartOpen]);

  useEffect(() => {
    const checkIsCartEmpty =
      cartItemsTemp?.length === 0 || cartItemsTemp === null;
    setisCartEmpty(checkIsCartEmpty);
  }, [cartItemsTemp]);

  const getUserFromLocalStorage = () => {
    try {
      return JSON.parse(localStorage.getItem(USER_DATA) || "");
    } catch (error) {
      return null;
    }
  };

  const isItemsFromDifferentSellers =
    new Set(cartItemsTemp?.map((item) => item?.catalogData?.providerId)).size >
    1;
  let totalAmount = 0;
  if (cartItems && cartItems !== undefined) {
    cartItems.forEach((item) => {
      totalAmount += item?.quantity * item?.catalogData.price;
    });
  }

  const updateCartItemQuantity = (itemId, newQuantity, singleCatalogData) => {
    const itemIndex = cartItemsTemp?.findIndex((item) => item._id === itemId);
    if (
      newQuantity > parseInt(singleCatalogData?.catalogData?.availableQuantity)
    ) {
      notify(
        "success",
        "Available Quantity is only " +
        singleCatalogData?.catalogData?.availableQuantity
      );
    } else if (
      newQuantity > parseInt(singleCatalogData?.catalogData?.maximumQuantity)
    ) {
      notify(
        "success",
        `Maximum quantity available is ${singleCatalogData?.catalogData?.maximumQuantity} for this product`
      );
    } else {
      if (itemIndex !== -1) {
        // Update the quantity of the item
        let updatedCartItems = cloneDeep(cartItemsTemp);
        if (newQuantity === 0) {
          const arr = updatedCartItems.filter(function (item) {
            return item !== updatedCartItems[itemIndex];
          });
          updatedCartItems = arr;
        } else {
          updatedCartItems = cartItems.map((item, index) =>
            index === itemIndex ? { ...item, quantity: newQuantity } : item
          );
        }
        setCartItemsTemp(updatedCartItems);
        const existingProviderId = cartItems?.[0]?.catalogData?.providerId;
        if (existingProviderId && updatedCartItems?.some(item => item?.catalogData?.providerId !== existingProviderId)) {
          notify("error", "You can add items from a single store at a time.");
        }
        else {
          handleAddToCart(
            singleCatalogData?.catalogData?.productName,
            singleCatalogData?.catalogData?._id,
            singleCatalogData?.catalogData?.subCategoryId,
            newQuantity,
            singleCatalogData?.catalogData?.price,
            singleCatalogData?.catalogData?.store?.name
          );
          localStorage.setItem("cart", JSON.stringify(updatedCartItems));
          dispatch(updateCartItem(updatedCartItems));
        }
      }
    }
  };

  const dispatchOndcSelect = () => {
    const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
    if (!token) {
      setModalIsOpen(true);
      setLoading(false);
      return;
    }
    if (!defaultAddress?.address?.address_line2) {
      setAddressModal(true);
      setLoading(false);
      return;
    }
    setLoading(true);
    setDisableCrossButton(true);
    setCartError("");
    const user = JSON.parse(localStorage.getItem("user"));
    const select_transaction_id = JSON.parse(
      localStorage.getItem("transaction_id")
    );
    const items = cartItemsTemp?.map((item) => ({
      id: item.catalogData._id,
      quantity: item.quantity,
    }));

    const transaction_id = select_transaction_id
      ? select_transaction_id
      : uuidv4();
    dispatch(
      ondcSelect({
        userAddress: defaultAddress?.address,
        items,
        userId: user?._id,
        transactionId: transaction_id,
        orderValue: parseFloat(totalAmount),
        landingSource: localStorage.getItem("landingSource") ? localStorage.getItem("landingSource") : ""
      })
    ).then((response) => {
      localStorage.setItem("transaction_id", JSON.stringify(transaction_id));
      setDisableCrossButton(false);
      setLoading(false);
      setOndcCartData(response?.payload?.data);
      if (
        response?.payload?.success &&
        response?.payload?.data &&
        !response?.payload?.data?.error
      ) {
        setCartError("");
        localStorage.setItem(
          "ondcCart",
          JSON.stringify(response?.payload?.data)
        );
        getUserFromLocalStorage() &&
          getUserFromLocalStorage() !== null &&
          getUserFromLocalStorage() !== ""
          ? navigate("/buyer-checkout")
          : setModalIsOpen(true);
      }
      else {
        if (response?.payload?.data?.error?.message?.length > 0) {
          try {
            setErrorData(JSON.parse(response?.payload?.data?.error?.message));
          } catch (e) {
            setCartError(response?.payload?.data?.error?.message);
          }
        }
        const errMsg = response?.payload?.data?.error?.message
          ? response?.payload?.data?.error?.message
          : response?.payload?.message;
        const error = errorCodeMessages(
          response?.payload?.data?.error?.code,
          errMsg
        );
        if (!response?.payload?.data?.error?.code) {
          setErrorPopupOpen(true);
          const err_with_id = `${errMsg}`;
          setErrMessage(err_with_id);
        }
        else if (response?.payload?.data?.error?.code === "40002") {
          setCartError("40002");
        }
        else {
          const err_with_id = `${error}`;
          setCartError(err_with_id);
        }
      }
    });
  };

  const disableCartItemInteraction = () => {
    return loading;
  };

  const handleSuccessfullLogin = () => {
    setModalIsOpen(false);
    setAddressModal(true);
  };

  const groupAndSortItems = (cartItems) => {
    const grouped = cartItems?.reduce((acc, item) => {
      const storename = item?.catalogData?.store?.name;
      if (!acc[storename]) {
        acc[storename] = [];
      }
      acc[storename].push(item);
      return acc;
    }, {});

    return cartItems?.length > 0
      ? Object.entries(grouped)
        .sort(([storenameA], [storenameB]) =>
          storenameA.localeCompare(storenameB)
        )
        .map(([storename, items]) => ({ storename, items }))
      : null;
  };
  const groupedCartItems = groupAndSortItems(cartItemsTemp);

  return (
    <>
      {process.env.REACT_APP_NODE_ENV === "production" && localStorage.getItem("landingSource")?.includes("qc") && (
        <Helmet>
          <script>
            {`!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '326242339368504');
fbq('track', 'PageView');
fbq('track', 'AddToCart');`}
          </script>
          <noscript>{`<img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=326242339368504&ev=PageView&noscript=1"
/>`}</noscript>
        </Helmet>
      )}
      <div id="offcanvasDiv" data-bs-dismiss="offcanvas"></div>
      <div className="drawer-header-kl">
        <div className="drawer-header-title-kl">My Cart</div>
        <button
          close
          disabled={disableCrossButton}
          onClick={closeCart}
          aria-label="Close"
          className="drawer-header-close-btn-kl"
        ></button>
      </div>
      <div className="drawer-body-kl p-0 mb-3">
        {isCartEmpty ? (
          <div className="cart-empty-body">
            <div className="nothing-match">
              <div className="no-cart-img">
                <img alt="No Data" src={NoCart} />
              </div>
              <h6 className="cart-empty">Your cart is empty</h6>
            </div>
          </div>
        ) : (
          <>
            <div className="cart-content-body-kl">
              <div className="cart-content-inner-kl">
                <div className="accordion my-card-accordion-kl" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        {groupedCartItems?.[0]?.storename || "Store"}{" "}
                        <span>{groupedCartItems?.[0]?.items?.length || 0} ({groupedCartItems?.[0]?.items?.length > 1 ? "Items" : "Item"})</span>
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      {groupedCartItems?.map(({ storename, items }) => {
                        return (
                          <div className="my-cart-accordion-list-kl" key={storename}>
                            {items?.map((cartData) => {
                              const errorItem = errorData?.find(
                                (item) =>
                                  item?.item_id === cartData?.productId
                              );
                              const errorCode = errorItem?.error;
                              const errorMessage = errorCode
                                ? errorCodeMessages(errorCode) || "Other not Found"
                                : null;
                              const item =
                                ondcCartData &&
                                ondcCartData?.message?.order?.quote?.breakup?.find(
                                  (item) =>
                                    item["@ondc/org/item_id"] ===
                                    cartData?.productId
                                );
                              const availableQuantity = item
                                ? item?.item?.quantity?.available?.count
                                : 0;
                              return (
                                <div className="my-cart-accordion-items-kl" key={cartData?._id}>
                                  <div className="my-cart-product-img-kl">
                                    <img
                                      src={cartData?.catalogData?.productImages?.[0]}
                                      alt="Product"
                                      onError={(event) => {
                                        event.target.onerror = null;
                                        event.target.src = BrandLogo;
                                        event.target.classList.add("default-img");
                                      }}
                                    />
                                  </div>
                                  <div className="my-cart-product-right-kl">
                                    <div className="my-cart-product-details-kl">
                                      <div className="product_text-kl">
                                        <div className="product-title-kl">
                                          {cartData?.catalogData?.productName}
                                        </div>
                                        <div className="my-cart-product-price-kl">
                                          ₹
                                          {cartData?.quantity *
                                            cartData?.catalogData?.price}
                                        </div>
                                      </div>
                                      <div
                                        id={`ui${cartData._id}`}
                                        className="plus-minus-qty-list-kl"
                                      >
                                        <div
                                          className={`plus-minus-qty-items-kl ${disableCartItemInteraction() &&
                                            "disabled"
                                            }`}
                                          onClick={() => {
                                            !disableCartItemInteraction() &&
                                              updateCartItemQuantity(
                                                cartData._id,
                                                cartData.quantity === 1
                                                  ? 0
                                                  : cartData.quantity - 1,
                                                cartData
                                              );
                                          }}
                                        >
                                          <MinusIcon />
                                        </div>
                                        <div className="input-field-kl">{cartData?.quantity ?? 0}</div>
                                        <div
                                          className={`plus-minus-qty-items-kl ${disableCartItemInteraction() &&
                                            "disabled"
                                            }`}
                                          onClick={() => {
                                            !disableCartItemInteraction() &&
                                              updateCartItemQuantity(
                                                cartData?._id,
                                                cartData?.quantity + 1,
                                                cartData
                                              );
                                          }}
                                        >
                                          <PlusIcon />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="return-cancel-kl">
                                      <div className="return-cancel-list-kl d-flex gap-2 align-items-center">
                                        <div className="cancellable-returnable-text-kl">
                                          {cartData?.catalogData?.isCancellable
                                            ? "Cancellable : Yes"
                                            : "Cancellable : No"}
                                        </div>
                                        <div className="cancellable-returnable-text-kl">
                                          {cartData?.catalogData?.isReturnable
                                            ? "Returnable : Yes"
                                            : "Returnable : No"}
                                        </div>
                                      </div>
                                      <button
                                        className={`cart-remove-btn-kl ${disableCartItemInteraction() && "disabled"
                                          }`}
                                        onClick={() => {
                                          !disableCartItemInteraction() &&
                                            updateCartItemQuantity(
                                              cartData?._id,
                                              0,
                                              cartData.catalogData
                                            );
                                        }}
                                      >
                                        <DeleteIcon />
                                        Remove
                                      </button>
                                    </div>
                                  </div>
                                  <>
                                    {errorMessage && (
                                      <div className="stock-error-kl full-width-columns">
                                        <div className="stock-error-msg-kl">
                                          {errorMessage}
                                        </div>
                                        {errorCode === "40002" && (
                                          <div className="d-flex align-items-center gap-3 cart-items-error">
                                            <p className="m-0">
                                              Cart Quantity: {cartData?.quantity}
                                            </p>
                                            <p className="m-0">
                                              Available Quantity: {availableQuantity}
                                            </p>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <button onClick={() => {
                    const providerId = groupedCartItems?.[0]?.items?.[0]?.catalogData?.providerId
                    const encodedValue = encodeURIComponent(providerId);
                    navigate(`/seller?pid=${encodedValue}`);
                    closeCart();
                  }} className="my-cart-add-more-product-btn-kl">Add More Items</button>
                </div>
                <div className="my-cart-bill-detail-container-kl">
                  <div className="bill-detail-container-inner-kl">
                    <div className="my-cart-bill-details-title-kl">Bill details</div>
                    <ul className="my-cart-total-list-kl">
                      <li>
                        <div className="d-flex align-items-center  gap-2">
                          <div className="my-cart-total-text-kl">Sub total</div>
                        </div>
                        <div className="my-cart-billCard-Price-kl">
                          <div className="my-cart-total-text-kl">₹{totalAmount?.toFixed(2)}</div>
                        </div>
                      </li>
                      <li>
                        <div>
                          <div className="total-text-kl">Grand total</div>
                        </div>
                        <div className="my-cart-billCard-Price-kl">
                          <div className="my-cart-total-text-kl">₹{totalAmount?.toFixed(2)}</div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                {shippingAddress?.address_line2 && (
                  <div className="accordion my-card-accordion-kl" id="accordionExample2">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingOne">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne2"
                          aria-expanded="true" aria-controls="collapseOne2">
                          Shipping Address
                        </button>
                      </h2>
                      <div id="collapseOne2" className="accordion-collapse collapse show" aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample2">
                        <div className="my-cart-shipping-address-kl">
                          <div className="my-cart-shipping-address-list-kl">
                            <div className="my-cart-shipping-address-items-kl">
                              {shippingAddress?.address_line2 ? (
                                <div className="my-cart-shipping-address-content-kl">
                                  <div className="shipping-address-kl">
                                    {`${shippingAddress?.contactName ?? ""}, ${shippingAddress?.address_line2 ?? ""}, ${shippingAddress?.zipcode ?? ""}`}
                                  </div>
                                  <div className="shipping-address-kl">
                                    {`phone: ${shippingAddress?.contactPhone ?? ""}`}
                                  </div>
                                </div>
                              ) : (
                                <div className="my-cart-shipping-address-btn-kl">
                                  <button
                                    type="button"
                                    className="add-address-btn-kl"
                                    onClick={() => {
                                      dispatchOndcSelect();
                                    }}
                                  >
                                    <Plus className="me-2" type="button" />
                                    Add Address
                                  </button>
                                </div>
                              )}
                              <div className="d-flex justify-content-between align-items-start">
                                {token && (
                                  <button
                                    className="edit-address-btn-kl"
                                    onClick={() => {
                                      setAddressModal(true);
                                    }}
                                  >
                                    Change Address
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="cancellation-policy-details-kl">
                  <div className="cancellation-policy-title-kl">Cancellation Policy</div>
                  <div className="cancellation-policy-description-kl">
                    Orders cannot be cancelled once packed for delivery. In case of unexpected delays, a refund will be provided, if applicable.
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {/* </div> */}
      {errorPopupOpen && (
        <div className="technical-issue-popup">
          <div onClick={() => setErrorPopupOpen(false)} className="cross-icon">
            <CrossIcon />
          </div>
          <div className="technical-popup-body">
            <div className="warning-icon">
              <img alt="WarningIcon" src={WarningIcon} />
            </div>
            <h1 className="technical-popup-heading">
              {" "}
              Uh-oh! Seller facing a technical issue
            </h1>
            {errMessage && (
              <p className="technical-popup-error">{errMessage}</p>
            )}
            <p className="technical-popup-para">
              Please try again or explore other stores
            </p>
            <button
              onClick={() => setErrorPopupOpen(false)}
              className="btn btn-primary w-100"
            >
              Try Again
            </button>
            <div className="text-center mt-4 mb-5">
              <a href="/" className="explore-stores">
                Explore Other Stores
              </a>
            </div>
          </div>
        </div>
      )}
      {!isCartEmpty && (
        <div className="my-cart-footer-kl">
          {isItemsFromDifferentSellers && (
            <p style={{ color: "red" }}>
              You are ordering from different stores. Please check your order
              again.
            </p>
          )}
          {cartError && cartError !== "40002" && <p className="error">{cartError}</p>}
          <button
            className="btn btn-primary position-relative"
            disabled={loading || isItemsFromDifferentSellers}
            onClick={() => {
              dispatchOndcSelect();
            }}
          >
            <div
              className="align-items-center gap-2"
              style={{ display: "inline-flex" }}
            >
              <div className="cart-items-l; text-left">
                <div className="cart-item-title-kl">Order Total</div>
                <div className="cart-item-price-kl">₹ {totalAmount?.toFixed(2)}</div>
              </div>
            </div>
            <div className="proceed-btn-kl">{"Proceed"}</div>
          </button>
          {loading && <div><LoaderWhite /></div>}
        </div>
      )}

      {modalIsOpen && (
        <Login
          isOpenFromCart={true}
          modalIsOpen={modalIsOpen}
          setModalIsOpen={setModalIsOpen}
          onSuccess={handleSuccessfullLogin}
        ></Login>
      )}
      <Modal
        isOpen={clearCart}
        aria-labelledby="contained-modal-title-vcenter"
        toggle={() => {
          setClearCart(false);
        }}
        centered
        className="clear-cart clearcartmodal "
      >
        <div className="clearCart">
          <img src={clearCartIcon} alt="Icon" />
          <h5 className="cart-title">Do you really want to clear the cart?</h5>
        </div>

        <ModalFooter className="border-0">
          <button
            onClick={() => {
              setClearCart(false);
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => {
              localStorage.removeItem("cart");
              setCartItemsTemp([]);
              setClearCart(false);
            }}
          >
            Clear
          </button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={addressModal}
        size="lg"
        toggle={() => setAddressModal(false)}
        className="custom-modal-kl"
      >
        <div className="addressmodalBlock">
          <ManageAddress
            onAddressSelected={dispatchOndcSelect}
            setZipcode={setZipcode}
            setAddressModal={setAddressModal}
            setShippingAddress={setShippingAddress}
            zipcode={zipcode}
            isInHeader={false}
          />
        </div>
      </Modal>
    </>
  );
};
export default Cart;
